import React, { useState, useEffect, useRef } from "react";
import styled from "styled-components";
// import ScrollContainer from "react-indiana-drag-scroll";
import { Link, useParams, useHistory } from "react-router-dom";
import { useSelector, connect } from "react-redux";
import { toast } from "react-toastify";
import axios from "axios";
import { logout, login as loginAction } from "../state/action-creator/index";
import InfiniteScroll from "react-infinite-scroll-component";
import "../sass/components/video-player.scss";
import { API_ENDPOINTS } from "../config/api";
import useTranslation from "../hooks/useTranslation";

import { Container } from "../layout/Container";
import { SmallAvatar } from "../components/Avatar";
import CardsContainer from "../layout/CardsContainer";
import ReportModal from "../components/modals/Report";
import FollowUnfollow from "../components/FollowUnfollow";
import Dropdown from "../components/Dropdown";
import NavTab from "../components/NavTab";
import Button from "../components/Button";
import Avatar from "../components/Avatar";
import Modal from "../components/Modal";
import {
  checkUrl,
  checkFacebook,
  checkInstagram,
  checkTwitter,
  checkYoutube,
  checkPaypal,
} from "../utils";
// Icons
import { ReactComponent as VerifiedIcon } from "../img/icons/verified.svg";
import { ReactComponent as CameraIcon } from "../img/icons/camera.svg";
import { ReactComponent as MoneyIcon } from "../img/icons/money.svg";
import { ReactComponent as ThreeDotsIcon } from "../img/icons/more.svg";
import { ReactComponent as FacebookIcon } from "../img/icons/social-media/facebook-square.svg";
import { ReactComponent as TwitterIcon } from "../img/icons/social-media/twitter-square.svg";
import { ReactComponent as InstagramIcon } from "../img/icons/social-media/instagram-square.svg";
import { ReactComponent as WebsiteIcon } from "../img/icons/social-media/website-square.svg";
import { ReactComponent as NoFollowersIllustration } from "../img/illustrations/no-followers.svg";
import ReportIcon from "../img/icons/report.svg";

import { VideoCards, ClippedMomentsCards, SiggestedVideoCards } from "../TmpData";

// Inline fallback YouTube icon (ensures availability and proper theming)
const YouTubeSvg = (props) => (
  <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" {...props}>
    <path d="M23.5 6.2a4.7 4.7 0 0 0-.8-2.2A3 3 0 0 0 20.5 3C18.7 2.8 12 2.8 12 2.8s-6.7 0-8.5.2A3 3 0 0 0 1.3 4a4.7 4.7 0 0 0-.8 2.2A31.2 31.2 0 0 0 .2 12c0 1.9.3 3.9.3 3.9a4.7 4.7 0 0 0 .8 2.2 3 3 0 0 0 2.2 1.1c1.8.2 8.5.2 8.5.2s6.7 0 8.5-.2a3 3 0 0 0 2.2-1.1 4.7 4.7 0 0 0 .8-2.2s.3-2 .3-3.9-.3-3.9-.3-3.9Z" fill="currentColor"/>
    <path d="M9.8 8.1v7.8l6.5-3.9-6.5-3.9Z" fill="#fff"/>
  </svg>
);

const Profile = ({ logout, login }) => {
  const { t } = useTranslation();
  const [index, setIndex] = useState(1);
  const { username } = useParams();
  const [data, setData] = useState({});
  const history = useHistory();
  const myUsername = useSelector((state) => state.user.data?.username);
  const myId = useSelector((state) => state.user.data?.id || state.user.data?._id);
  const currentUser = useSelector((state) => state.user.data);

  // Debug logs


  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const isMyProfile = !username || username === myUsername;
    setLoading(true);
    // Public profile (by username) uses stream-service public endpoint.
    if (!isMyProfile && username) {
      axios
        .get(`/api/stream/profile/${encodeURIComponent(username)}`, { withCredentials: true })
        .then((res) => {
          setData(res.data || {});
          setLoading(false);
        })
        .catch(() => {
          setLoading(false);
          history.push("/404");
        });
      return;
    }

    // My profile (no username param, or username matches myUsername) still uses /me.
    // If user isn't logged in and hits /profile, keep existing auth behavior.
    if (!myUsername) {
      setLoading(false);
      history.push("/?noAuth");
      return;
    }

    axios
      .get(API_ENDPOINTS.AUTH_ME, { withCredentials: true })
      .then((res) => {
        const userFromApi = res.data.user || res.data;
        setData(userFromApi);

        // Keep Redux user in sync only for my profile.
        if (login && userFromApi) login(userFromApi);

        // Merge channel profile (about, socials, paypal) for bio display.
        if (userFromApi?.username) {
          axios
            .get(`/api/stream/profile/${encodeURIComponent(userFromApi.username)}`, { withCredentials: true })
            .then((prof) => {
              if (prof?.data) {
                const ch = prof.data;
                setData((prev) => ({
                  ...(prev || {}),
                  about: ch.about,
                  social: ch.social || ch.stream_socials || prev?.social,
                  paypalme: ch.paypalme ?? prev?.paypalme,
                  banner: ch.banner ?? prev?.banner,
                  verified: ch.verified ?? prev?.verified,
                  isLive: ch.isLive ?? prev?.isLive,
                }));
              }
            })
            .catch(() => {});
        }

        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        if (err.response?.status === 401) logout();
        else history.push("/404");
      });
  }, [username, myUsername, history, logout, login]);

  const isOwner = () => {
    // /me returns user id in `id`, while public stream profiles return `userId`.
    const profileUserId = data?.userId || data?.id || data?._id;
    const currentId = myId;
    if (!profileUserId || !currentId) return false;
    return String(profileUserId) === String(currentId);
  };

  const list = [t('profile.about'), isOwner() ? t('profile.my_videos') : t('profile.videos')];
  
  // Show loading state while fetching data
  if (loading || !data || !data.id) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '400px' }}>
        <div>{t('profile.loading_profile')}</div>
      </div>
    );
  }
  
  return (
    <div>
      <Header data={data} setData={setData} isOwner={isOwner} login={login} currentUser={currentUser} />
      <Container style={{ paddingBottom: "3rem" }}>
        <NavTabStyle
          rightComponent={
            !isOwner() && (
              <Actions paypal={data.paypalme} channelId={data.id} followed={data.isFollowed} />
            )
          }
          list={list}
          index={index}
          setIndex={setIndex}
        />
        {index === 1 && <About data={data} isOwner={isOwner} />}
        {index === 2 && <MyVideos username={data?.username} isOwner={isOwner} />}
      </Container>
    </div>
  );
};
// export default Profile;
export default connect(null, { logout, login: loginAction })(Profile);

const NavTabStyle = styled(NavTab)`
  @media (max-width: 576px) {
    margin-top: 140px;
    div {
      :nth-child(1) {
        margin: 0;
        width: 100%;
        text-align: center;
        > div {
          flex: 1;
        }
      }
    }
  }
`;

const Spinner = styled.div`
  position: absolute;
  top: 47%;
  left: 47%;
  z-index: 220;
  translate: transform(-50%, -50%) !important;
  opacity: 1;

  .col-sm-2 {
    padding: 10px;
    border-radius: 4px;
    height: 125px;
    margin-bottom: 10px;
  }

  .sp {
    width: 32px;
    height: 32px;
  }
`;

const Actions = (props) => {
  const { t } = useTranslation();
  const [drop, setdrop] = useState(false);
  const [reportModal, setReportModal] = useState(false);

  const MoreOptions = [
    {
      type: 2,
      title: t('profile.report'),
      icon: ReportIcon,
      func: showReportModal,
    },
  ];

  function hideReportModal() {
    setReportModal(false);
  }
  function showReportModal() {
    setReportModal(true);
  }

  return (
    <ActionsStyle>
      <div>
        {props.paypal && (
          <Button href={checkPaypal(props.paypal)} target="_blank" variant="danger" size="small">
            <MoneyIcon />
            {t('profile.donate')}
          </Button>
        )}
        <FollowUnfollow {...props} />
      </div>
      <Button
        onClick={() => {
          setdrop(!drop);
        }}
        icon
        style={{ position: "relative", maxWidth: "33px" }}
      >
        <ThreeDotsIcon />
        {drop && (
          <Dropdown
            show={drop}
            setShow={() => {
              setdrop(!drop);
            }}
            style={{ top: "100%" }}
            options={MoreOptions}
            margin="10px"
          ></Dropdown>
        )}
      </Button>
      <Modal isOpen={reportModal} onRequestClose={hideReportModal} hideModal={hideReportModal}>
        <ReportModal id={1} hideModal={hideReportModal} /> {/*Report Id*/}
      </Modal>
    </ActionsStyle>
  );
};
const ActionsStyle = styled.div`
  display: flex;
  > div {
    display: flex;
    justify-content: center;
    margin-right: 5px;
    button,
    a {
      flex: 1;
    }
    > button {
      margin-left: 5px;
    }
  }
  @media (max-width: 576px) {
    margin-bottom: 30px;
    flex: 1;
    a,
    button:nth-child(2) {
      flex: 1;
      max-width: 50%;
    }
    > button {
      display: none;
    }
  }
`;
const HeaderStyle = styled.header`
  width: 100%;
  min-height: 400px;
  max-height: 600px;
  height: 30vw;
  background-color: ${({ theme }) => theme.color.secondaryBg};
  background-image: ${({ banner }) => banner ? `url("${banner}")` : 'none'};
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  border-radius: 0px 0px 10px 10px;
  margin-bottom: 150px;
  position: relative;

  > h6 {
    font-size: 24px;
    margin-top: 15px;
    svg {
      width: 15px;
      height: 15px;
      top: 47%;
      right: -20px;
    }
  }
  input {
    display: none;
  }
  
  /* Banner upload overlay - shows on hover */
  &:hover .banner-upload-overlay {
    opacity: 1;
  }
  
  .banner-upload-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.4);
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0;
    transition: opacity 300ms ease;
    z-index: 5;
    
    label {
      cursor: pointer;
      background: rgba(0, 0, 0, 0.8);
      border-radius: 50px;
      color: white;
      padding: 12px 24px;
      font-weight: 600;
      font-size: 14px;
      display: flex;
      align-items: center;
      gap: 8px;
      
      svg {
        width: 20px;
        height: 20px;
        color: white;
      }
      
      &:hover {
        background: rgba(0, 0, 0, 0.9);
      }
    }
  }
  .banner-controls {
    position: absolute;
    right: 16px;
    bottom: 16px;
    z-index: 6;
    display: flex;
    align-items: center;
    gap: 8px;
  }
  .avatar-container {
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translate(-50%, 50%);
    cursor: default;
    
    > div {
      position: relative;
    }
    
    &:hover .avatar-upload-overlay {
      opacity: 1;
    }
    
    .avatar-upload-overlay {
      position: absolute;
      top: 0;
      left: 0;
      border-radius: 100px;
      overflow: hidden;
      width: 150px;
      height: 150px;
      background: rgba(0, 0, 0, 0.7);
      display: flex;
      align-items: center;
      justify-content: center;
      opacity: 0;
      transition: opacity 300ms ease;
      z-index: 10;
      
      label {
        cursor: pointer;
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        gap: 5px;
        
        svg {
          width: 35px;
          height: 29px;
          color: white;
        }
        
        span {
          color: white;
          font-size: 12px;
        }
      }
    }
    .avatar-controls {
      position: absolute;
      top: 160px;
      left: 50%;
      transform: translateX(-50%);
      z-index: 11;
      display: flex;
      align-items: center;
      gap: 8px;
    }
  }
  @media (max-width: 576px) {
    min-height: 250px;
    margin-bottom: 110px;
    
    & > div:first-child {
      > a > div {
        max-width: 130px;
        max-height: 130px;
      }
    }
    
    .avatar-container {
      .avatar-upload-overlay {
        width: 130px;
        height: 130px;
      }
      .avatar-controls {
        top: 140px;
        left: 50%;
        transform: translateX(-50%);
      }
    }
    
    a:nth-child(1) {
      width: clamp(130px, 130px, 130px);
      height: clamp(130px, 130px, 130px);
    }
  }
`;
const UploadButton = styled(Button)`
  background: rgba(0, 0, 0, 0.6);
  color: #fff;
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 24px;
  padding: 8px 12px;
  line-height: 1;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);
  svg {
    color: #fff;
    width: 16px;
    height: 16px;
  }
`;
const NoFollowers = () => {
  const { t } = useTranslation();
  return (
    <div style={{ display: "block", textAlign: "center" }}>
      <NoFollowersIllustration style={{ maxWidth: "70%", height: "auto", marginBottom: "30px" }} />
      <div style={{ justifyContent: "center" }}>{t('profile.no_followers')}</div>
    </div>
  );
};
const Followers = ({ hideModal, followersLenght, logout }) => {
  const { t } = useTranslation();
  const [followers, setFollowers] = useState([]);
  const [loading, setLoading] = useState(1);
  const [hasMore, sethasMore] = useState(true);

  const [index, setIndex] = useState(1);
  useEffect(() => {
    axios
      .get(process.env.REACT_APP_FOLLOWERS_ENDPOINT + index, {
        withCredentials: true,
      })
      .then((res) => {
        setFollowers((prev) => [...prev, ...res.data]);
        setLoading(0);
      })
      .catch((err) => {
        if (err.response?.status === 401) logout();
      });
  }, [index, logout]);

  const handleRemove = (e, id) => {
    // console.log(id);
    e.target.remove();
    // Remove Follower Request
    toast.success("Removed");
  };
  function fetchMoreData() {
    // a fake async api call like which sends
    // 20 more records in 1.5 secs
    if (followersLenght === followers.length) {
      sethasMore(false);
      return;
    }
    setTimeout(() => {
      setIndex((prev) => prev + 1);
    }, 1000);
  }

  return (
    <FollowerStyle>
      {loading === 1 ? (
        <Spinner id="spinner" className="	sp sp-circle"></Spinner>
      ) : followers.length !== 0 ? (
        <InfiniteScroll
          style={{
            width: "100%",
            height: "100%",
            maxHeight: "310px",
            overflow: "auto",
          }}
          height={310}
          dataLength={followers.length}
          next={fetchMoreData}
          hasMore={hasMore}
          loader={<LilSpin>{t('profile.loading')}</LilSpin>}
        >
          {followers.map((follower, index) => (
            <div key={index}>
              <div>
                <SmallAvatar
                  size="40px"
                  to={"/profile/" + follower.username}
                  src={follower.avatar}
                  alt={follower.username}
                  onClick={hideModal}
                />
                <div style={{ marginLeft: "5px" }}>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <Link onClick={hideModal} to={"/profile/" + follower.username}>
                        <h6>{follower.username}</h6>
                      </Link>
                      {follower.isVerified && <VerifiedIcon />}
                    </div>
                    <FollowUnfollow
                      style={{
                        padding: "0",
                        boxShadow: "none",
                        background: "transparent",
                        color: "black",
                      }}
                      follow
                      noIcons
                    />
                  </div>
                  <span>{follower.username}</span>
                </div>
              </div>
              <Button size="small" link onClick={(e) => handleRemove(e, follower.id)}>
                {t('profile.remove')}
              </Button>
            </div>
          ))}
        </InfiniteScroll>
      ) : (
        <NoFollowers />
      )}
    </FollowerStyle>
  );
};

const LilSpin = styled.div`
  color: ${({ theme }) => theme.color.primaryText};
  display: flex;
  justify-content: center;
`;
const FollowerStyle = styled.div`
  margin-top: 40px;
  padding: 3px;
  padding-left: 0;
  min-height: 300px;

  a {
    color: ${({ theme }) => theme.color.darkerText};
    margin-right: 5px;
  }
  > div {
    display: flex;
    align-items: center;
    justify-content: space-between;
    > div {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
      span {
        font-size: 14px;
      }
      > div {
        display: flex;
        flex-direction: row;
        align-items: center;
        width: 100%;
        margin-bottom: 20px;
        > div {
          display: flex;
          flex-direction: row;
          align-items: center;
          width: 100%;
        }
      }
    }
    :not(:last-child) {
      margin-bottom: 20px;
    }
  }
`;
const Header = ({ logout, data, setData, isOwner, login, currentUser }) => {
  // All hooks must be called before any early returns
  const { t } = useTranslation();
  const [followersModal, setFollowersModal] = useState(false);
  const [avatarImg, setAvatarImg] = useState(null);
  const [avatarPrev, setAvatarPrev] = useState("");
  const [bannerImg, setBannerImg] = useState(null);
  const [bannerPrev, setBannerPrev] = useState("");
  const [isUploadingAvatar, setIsUploadingAvatar] = useState(false);
  const [isUploadingBanner, setIsUploadingBanner] = useState(false);
  const bannerInputRef = useRef(null);
  const avatarInputRef = useRef(null);

  const addCacheBuster = (url) => {
    if (!url) return url;
    const s = String(url);
    return `${s}${s.includes("?") ? "&" : "?"}t=${Date.now()}`;
  };

  const refreshMeAndSync = async () => {
    try {
      const me = await axios.get(API_ENDPOINTS.AUTH_ME, { withCredentials: true });
      const freshUser = me?.data?.user || me?.data;
      if (!freshUser) return null;
      const synced = {
        ...freshUser,
        avatar: addCacheBuster(freshUser.avatar),
        banner: addCacheBuster(freshUser.banner),
      };
      // Update Profile page local state + Redux store
      setData((prev) => ({ ...(prev || {}), ...synced }));
      if (login) login(synced);
      return synced;
    } catch (err) {
      if (err?.response?.status === 401) logout();
      return null;
    }
  };

  useEffect(() => {
    if (avatarImg && !isUploadingAvatar) {
      setIsUploadingAvatar(true);
      let formData = new FormData();
      formData.append("filename", avatarImg);
      
      console.log("📤 Uploading avatar to:", API_ENDPOINTS.AVATAR);
      
      axios
        .post(API_ENDPOINTS.AVATAR, formData, {
          withCredentials: true,
          headers: {
            "Content-type": "multipart/form-data",
          },
        })
        .then(async (res) => {
          console.log("✅ Avatar upload success:", res.data);
          toast.success("Profile picture updated successfully!");
          setIsUploadingAvatar(false);

          // Prefer authoritative refresh from /me (handles APIs that don't return the new URL)
          // Fallback to response URL if present.
          const serverUrl = res?.data?.newAvatar || res?.data?.avatar;
          if (serverUrl) {
            const cacheBusted = addCacheBuster(serverUrl);
            setData((prevData) => ({ ...(prevData || {}), avatar: cacheBusted }));
            if (currentUser && login) login({ ...currentUser, avatar: cacheBusted });
          } else {
            await refreshMeAndSync();
          }

          // Clear preview and selected file regardless
          setAvatarPrev("");
          setAvatarImg(null);
        })
        .catch((err) => {
          console.error("❌ Avatar upload error:", err.response?.data || err);
          setIsUploadingAvatar(false);
          setAvatarPrev(""); // Clear preview on error
          setAvatarImg(null); // Clear selected file on error
          if (err.response?.status === 401) logout();
          else toast.error(err.response?.data?.errors?.[0]?.msg || "Avatar upload failed");
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [avatarImg]); // ✅ Removed logout and isUploadingAvatar from dependencies

  useEffect(() => {
    if (bannerImg && !isUploadingBanner) {
      setIsUploadingBanner(true);
      let formData = new FormData();
      formData.append("filename", bannerImg);
      
      console.log("📤 Uploading banner to:", API_ENDPOINTS.BANNER);
      
      axios
        .post(API_ENDPOINTS.BANNER, formData, {
          withCredentials: true,
          headers: {
            "Content-type": "multipart/form-data",
          },
        })
        .then(async (res) => {
          console.log("✅ Banner upload success:", res.data);
          toast.success("Banner updated successfully!");
          setIsUploadingBanner(false);

          // Prefer authoritative refresh from /me (handles APIs that don't return the new URL)
          // Fallback to response URL if present.
          const serverUrl = res?.data?.newBanner || res?.data?.banner;
          if (serverUrl) {
            const cacheBusted = addCacheBuster(serverUrl);
            setData((prevData) => ({ ...(prevData || {}), banner: cacheBusted }));
            if (currentUser && login) login({ ...currentUser, banner: cacheBusted });
          } else {
            await refreshMeAndSync();
          }

          // Clear preview and selected file regardless
          setBannerPrev("");
          setBannerImg(null);
        })
        .catch((err) => {
          console.error("❌ Banner upload error:", err.response?.data || err);
          setIsUploadingBanner(false);
          setBannerPrev(""); // Clear preview on error
          setBannerImg(null); // Clear selected file on error
          if (err.response?.status === 401) logout();
          else toast.error(err.response?.data?.errors?.[0]?.msg || "Banner upload failed");
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bannerImg]); // ✅ Removed logout and isUploadingBanner from dependencies

  function hideModal() {
    setFollowersModal(false);
  }
  function showModal() {
    if (isOwner()) setFollowersModal(true);
  }

  const uploadBanner = (e) => {
    e.preventDefault();
    setBannerImg(e.target.files[0]);
    setBannerPrev(URL.createObjectURL(e.target.files[0]));
  };
  const uploadAvatar = (e) => {
    e.preventDefault();
    setAvatarImg(e.target.files[0]);
    setAvatarPrev(URL.createObjectURL(e.target.files[0]));
  };
  const triggerBannerPicker = () => {
    if (isOwner() && bannerInputRef.current && !isUploadingBanner) {
      bannerInputRef.current.click();
    }
  };
  const triggerAvatarPicker = () => {
    if (isOwner() && avatarInputRef.current && !isUploadingAvatar) {
      avatarInputRef.current.click();
    }
  };
  
  // Debug logs after all hooks
  console.log('🔍 [HEADER] Data received:', data);
  console.log('🔍 [HEADER] isOwner:', isOwner());
  console.log('🔍 [HEADER] username:', data?.username);
  console.log('🔍 [HEADER] avatar:', data?.avatar);
  console.log('🔍 [HEADER] banner:', data?.banner);
  console.log('🎨 [HEADER] Banner URL for CSS:', bannerPrev || data.banner);
  
  // Don't render if no data (after all hooks)
  if (!data || !data.username) {
    return null;
  }
  
  return (
    <HeaderStyle banner={bannerPrev || data.banner}>
      <Modal isOpen={followersModal} onRequestClose={hideModal} hideModal={hideModal}>
        <h3>{t('profile.followers_title')}</h3>
        <Followers hideModal={hideModal} followersLenght={data.followers} />
      </Modal>
      
      {isOwner() && (
        <div className="banner-controls">
          <UploadButton onClick={triggerBannerPicker} disabled={isUploadingBanner} size="small">
            <CameraIcon />
            <span style={{ marginLeft: 6 }}>{isUploadingBanner ? t('profile.uploading') : t('profile.change_banner')}</span>
          </UploadButton>
          <input ref={bannerInputRef} type="file" onChange={uploadBanner} accept="image/*" disabled={isUploadingBanner} style={{ display: 'none' }} />
        </div>
      )}
      
      <div className="avatar-container">
        <Avatar
          clickAble={isOwner()}
          size="150px"
          src={avatarPrev || data.avatar}
          alt={data.username}
          name={data.username}
          isLive={data.isLive}
          isVerified={data.verified}
          followers={data.followers}
          onFollowersClick={showModal}
        />
        {isOwner() && (
          <>
            <div className="avatar-upload-overlay">
              <label onClick={triggerAvatarPicker}>
                <CameraIcon />
                <span>{isUploadingAvatar ? t('profile.uploading') : t('profile.change_avatar')}</span>
              </label>
            </div>
            <input ref={avatarInputRef} type="file" onChange={uploadAvatar} accept="image/*" disabled={isUploadingAvatar} style={{ display: 'none' }} />
          </>
        )}
      </div>
    </HeaderStyle>
  );
};

const About = ({ data }) => {
  const svgStyle = { width: "20px", height: "20px", maxWidth: "20px", maxHeight: "20px" };
  const socials = data?.social || data?.stream_socials || {};
  const socialItems = [
    socials.facebook ? { key: "facebook", label: "Facebook", href: checkFacebook(socials.facebook), Icon: FacebookIcon } : null,
    socials.twitter ? { key: "twitter", label: "Twitter", href: checkTwitter(socials.twitter), Icon: TwitterIcon } : null,
    socials.instagram ? { key: "instagram", label: "Instagram", href: checkInstagram(socials.instagram), Icon: InstagramIcon } : null,
    socials.youtube ? { key: "youtube", label: "YouTube", href: checkYoutube(socials.youtube), Icon: YouTubeSvg } : null,
    socials.website ? { key: "website", label: "Website", href: checkUrl(socials.website), Icon: WebsiteIcon } : null,
  ].filter(Boolean);

  return (
    <AboutStyle>
      <InfoCard>
        <CardTitle>About</CardTitle>
        <p className="about-text">
          {data.about && String(data.about).trim().length > 0 ? data.about : "No bio yet."}
        </p>

        <Divider />
        <StatsRow style={{ gridTemplateColumns: '1fr' }}>
          <StatItem>
            <span className="stat-label">Followers</span>
            <span className="stat-value">{Number(data.followers || 0).toLocaleString()}</span>
          </StatItem>
        </StatsRow>

        <Divider />
        {socialItems.length > 0 ? (
          <SocialList>
            {socialItems.map(({ key, label, href, Icon }) => (
              <SocialItem key={key} href={href} target="_blank" rel="noopener noreferrer">
                <Icon style={svgStyle} />
                <span>{label}</span>
              </SocialItem>
            ))}
          </SocialList>
        ) : (
          <EmptyHint>No social links added yet.</EmptyHint>
        )}

        {(data?.paypalme && String(data.paypalme).trim().length > 0) && (
          <>
            <Divider />
            <div style={{ display: "flex", justifyContent: "flex-start" }}>
              <Button href={checkPaypal(data.paypalme)} target="_blank" variant="danger">
                <MoneyIcon />
                <span style={{ marginLeft: 6 }}>Donate via PayPal.me</span>
              </Button>
            </div>
          </>
        )}
      </InfoCard>
    </AboutStyle>
  );
};
const AboutStyle = styled.div`
  margin-top: "4vw";
  > div {
    margin: 20px 0 30px;
  }
  > section {
    h4 {
      margin-bottom: 20px;
    }
    > div {
      display: flex;
      flex-wrap: nowrap;
      > div {
        z-index: 1;
        padding: 20px 25px;
        border-radius: 5px;
        transition: color 200ms;
        :hover {
          background-color: ${({ theme }) => theme.color.secondaryBg};
          transition: background-color 300ms;
        }
      }
    }
    @media (max-width: 576px) {
      h4 {
        margin-bottom: 10px;
      }
      > div {
        > div {
          padding: 1.5rem;
        }
      }
    }
  }
`;
// const AboutGrid = styled.div`
//   display: grid;
//   grid-template-columns: 1.2fr 1fr;
//   gap: 24px;
//   @media (max-width: 992px) {
//     grid-template-columns: 1fr;
//   }
// `;
const InfoCard = styled.div`
  background: ${({ theme }) => theme.color.secondaryBg};
  border-radius: 10px;
  padding: 20px;
  border: 1px solid ${({ theme }) => theme.color.border};
  .about-text {
    color: ${({ theme }) => theme.color.text};
    line-height: 1.6;
    margin: 0;
    white-space: pre-wrap;
  }
`;
const CardTitle = styled.h4`
  margin: 0 0 14px 0;
  font-size: 18px;
  color: ${({ theme }) => theme.color.text};
`;
const Divider = styled.hr`
  border: none;
  border-top: 1px solid ${({ theme }) => theme.color.border};
  margin: 16px 0;
`;
const StatsRow = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
  @media (max-width: 576px) {
    grid-template-columns: 1fr;
  }
`;
const StatItem = styled.div`
  display: flex;
  flex-direction: column;
  background: ${({ theme }) => theme.color.secondaryBg};
  padding: 10px 0;
  .stat-label {
    font-size: 12px;
    color: ${({ theme }) => theme.color.lighterText};
  }
  .stat-value {
    font-size: 16px;
    color: ${({ theme }) => theme.color.text};
    font-weight: 600;
  }
`;
// const LiveBadge = styled.span`
//   display: inline-flex;
//   align-items: center;
//   padding: 4px 10px;
//   border-radius: 999px;
//   font-size: 12px;
//   background: ${({ live, theme }) => (live ? theme.color.danger : theme.color.secondaryBg)};
//   color: ${({ live, theme }) => (live ? "#fff" : theme.color.lighterText)};
//   border: 1px solid ${({ live, theme }) => (live ? theme.color.danger : theme.color.border)};
// `;
const SocialList = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  @media (max-width: 576px) {
    grid-template-columns: 1fr;
  }
`;
const SocialItem = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  background: ${({ theme }) => theme.color.secondaryBg};
  border: 1px solid ${({ theme }) => theme.color.border};
  border-radius: 8px;
  color: ${({ theme }) => theme.color.text};
  text-decoration: none;
  transition: background-color 200ms ease, border-color 200ms ease;
  &:hover {
    background: ${({ theme }) => theme.color.secondaryBgHover || theme.color.secondaryBg};
    border-color: ${({ theme }) => theme.color.primary};
  }
  span {
    font-size: 14px;
  }
  /* Ensure SVG icons are visible in dark mode by inheriting text color */
  svg {
    width: 20px;
    height: 20px;
    display: inline-block;
  }
  svg, svg * {
    fill: currentColor !important;
    stroke: currentColor !important;
  }
`;
const EmptyHint = styled.p`
  color: ${({ theme }) => theme.color.lighterText};
  margin: 6px 0 0;
  font-size: 14px;
`;
const MyVideos = ({ username, isOwner }) => {
  const { t } = useTranslation();
  const [replays, setReplays] = useState([]);
  const [replaysLoading, setReplaysLoading] = useState(true);
  const [replaysPage, setReplaysPage] = useState(1);
  const [hasMoreReplays, setHasMoreReplays] = useState(false);
  const [loadingMore, setLoadingMore] = useState(false);

  useEffect(() => {
    loadReplays();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [username, isOwner]);

  const loadReplays = async () => {
    try {
      if (!isOwner && !username) {
        setReplays([]);
        setHasMoreReplays(false);
        setReplaysPage(1);
        return;
      }

      const api = await import("../services/replaysApi");
      const data = isOwner
        ? await api.getMyReplays(1, 10)
        : await api.getUserReplaysByUsername(username, 1, 10);
      setReplays(data.replays || []);
      setHasMoreReplays(data.pagination?.hasMore || false);
      setReplaysPage(1);
    } catch (err) {
      console.error("Error loading replays:", err);
      // For public profiles, failing to load replays shouldn't block the page.
      setReplays([]);
      setHasMoreReplays(false);
    } finally {
      setReplaysLoading(false);
    }
  };

  const loadMoreReplays = async () => {
    if (loadingMore) return;
    setLoadingMore(true);
    try {
      const api = await import("../services/replaysApi");
      const nextPage = replaysPage + 1;
      const data = isOwner
        ? await api.getMyReplays(nextPage, 10)
        : await api.getUserReplaysByUsername(username, nextPage, 10);
      setReplays([...replays, ...(data.replays || [])]);
      setHasMoreReplays(data.pagination?.hasMore || false);
      setReplaysPage(nextPage);
    } catch (err) {
      console.error("Error loading more replays:", err);
    } finally {
      setLoadingMore(false);
    }
  };

  const handleReplayDeleted = (replayId) => {
    setReplays(replays.filter(r => r.id !== replayId));
  };

  return (
    <div>
      {/* Past Streams Section */}
      <div style={{ marginTop: "4vw" }}>
        <SectionTitle>
          <h2>{t('profile.past_streams')}</h2>
        </SectionTitle>
        {replaysLoading ? (
          <div style={{ textAlign: "center", padding: "40px" }}>{t('profile.loading_replays')}</div>
        ) : replays.length === 0 ? (
          <EmptyState>
            <div>
              <NoFollowersIllustration style={{ maxWidth: "300px", height: "auto", marginBottom: "20px" }} />
              <p style={{ fontSize: "18px", marginBottom: "10px" }}>{t('profile.no_recordings_yet')}</p>
              <p style={{ color: "#888", fontSize: "14px" }}>
                {t('profile.start_streaming_message')}
              </p>
            </div>
          </EmptyState>
        ) : (
          <>
            <ReplaysGrid>
              {replays.map((replay) => {
                const ReplayCard = require("../components/cards/Replay").default;
                return (
                  <ReplayCard 
                    key={replay.id} 
                    replay={replay} 
                    onDelete={handleReplayDeleted}
                  />
                );
              })}
            </ReplaysGrid>
            {hasMoreReplays && (
              <LoadMoreButton>
                <Button onClick={loadMoreReplays} disabled={loadingMore}>
                  {loadingMore ? t('profile.loading') : t('profile.load_more')}
                </Button>
              </LoadMoreButton>
            )}
          </>
        )}
      </div>

      {/* Existing Video Sections */}
      <CardsContainer
        style={{ marginTop: "4vw" }}
        full="true"
        cardsselection={SiggestedVideoCards}
        title={t('profile.recent_added')}
      />
      <CardsContainer
        style={{ marginTop: "4vw" }}
        full="true"
        cardsselection={ClippedMomentsCards}
        title={t('profile.best_clips')}
      />
      <CardsContainer
        style={{ marginTop: "4vw" }}
        full="true"
        cardsselection={VideoCards}
        title={t('profile.all_videos')}
      />
    </div>
  );
};

const SectionTitle = styled.div`
  margin-bottom: 20px;

  h2 {
    font-size: 24px;
    font-weight: 600;
    color: ${({ theme }) => theme.color.text};
    margin: 0;
  }
`;

const ReplaysGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 24px;
  margin-bottom: 24px;

  @media (max-width: 768px) {
    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
    gap: 16px;
  }

  @media (max-width: 576px) {
    grid-template-columns: 1fr;
  }
`;

const EmptyState = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 300px;
  text-align: center;
  padding: 40px 20px;

  p {
    color: ${({ theme }) => theme.color.text};
  }
`;

const LoadMoreButton = styled.div`
  display: flex;
  justify-content: center;
  margin: 24px 0;

  button {
    min-width: 200px;
  }
`;

// connect({ logout })(Followers, Profile, Header);
// export default connect(null, { logout })(Profile);
// 